/**
 * CastNSlidePreview – fullscreen preview of a single slide
 * Route: /castn/preview/:slideId (PrivateRoute)
 */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { Box, Typography, CircularProgress } from '@mui/material';
import { SlideRenderer } from './CastNDisplay';

export default function CastNSlidePreview() {
  const { slideId } = useParams();
  const [slide, setSlide] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slideId) return;
    getDoc(doc(db, 'slides', slideId)).then(snap => {
      if (snap.exists()) setSlide({ id: snap.id, ...snap.data() });
      setLoading(false);
    });
  }, [slideId]);

  if (loading) return (
    <Box sx={{ width:'100vw', height:'100vh', bgcolor:'#111', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <CircularProgress sx={{ color:'#FF6B00' }} />
    </Box>
  );

  if (!slide) return (
    <Box sx={{ width:'100vw', height:'100vh', bgcolor:'#111', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <Typography sx={{ color:'#555' }}>Anslaget hittades inte (ID: {slideId})</Typography>
    </Box>
  );

  return (
    <Box sx={{ width:'100vw', height:'100vh', bgcolor:'#111', position:'relative', overflow:'hidden' }}>
      <SlideRenderer slide={slide} />
      {/* Overlay badge */}
      <Box sx={{ position:'fixed', bottom:12, right:16, bgcolor:'rgba(0,0,0,0.6)', color:'#aaa',
        fontSize:'0.7rem', px:1.5, py:0.5, borderRadius:1, backdropFilter:'blur(4px)', pointerEvents:'none' }}>
        FÖRHANDSVISNING · {slide.type} · {slide.title || ''}
      </Box>
    </Box>
  );
}
